


















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class CvvInput extends Vue {
  @Prop({ default: '' }) private value!: string
  @Prop({ default: '' }) private error!: string
  @Prop({ default: false }) private readonly!: boolean

  private onInput(e: Event) {
    const target = e.target as HTMLInputElement
    this.$emit('input', target ? target.value : '')
  }
}
